import { Icon } from "@iconify/react";
import { Link } from "react-router-dom";
const TopRaffles = (props) => {
  return (
    <>
      <div className="row">
        {props.ArrayS.map((item, index) => {
          return (
            <div
              className="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12"
              key={index}
            >
              <Link to="/nft-detail" style={{ color: "transparent" }}>
                <div className="top-raffle-single">
                  <div className="heart-love text-end">
                    <div className="icon-wrapping-hears">
                      <Icon
                        icon="ant-design:heart-filled"
                        className="heart-icon-single"
                      />
                      <span>1.2k</span>
                    </div>
                  </div>
                  <img className="top-raffle-single-img" src={item.firstImg} />
                  <div className="d-flex align-items-center top-raffle-first">
                    <img className="top-raffle-prof-imgp" src={item.profImg} />

                    <h3 className="raffle-it">{item.title}</h3>
                  </div>

                  <div className="d-flex align-items-center justify-content-between top-raffle-second">
                    <h3 className="instock">
                      in stock <span>{item.inStock}</span>
                    </h3>
                    <div className="d-flex align-items-center justify-content-between price">
                      <h3 className="price-tit">
                        price:
                        <img
                          className="etheriumico"
                          src="../../../assets/images/topraffle/img4.png"
                        />
                        <span>{item.price}</span>
                      </h3>
                    </div>
                  </div>
                  <div className="forborder-bott"></div>

                  <div className="d-flex align-items-center bottom-items justify-content-between top-raffle-third">
                    <div className="d-flex align-items-center">
                      <img
                        className="top-raffle-prof-imgp"
                        src={item.userImg}
                      />

                      <h3 className="seller-name">{item.userName}</h3>
                    </div>
                    <div>
                      <button className="place-bid">
                        {props.buttontext == null ||
                        props.buttontext == undefined
                          ? "Place a bid"
                          : props.buttontext}
                      </button>
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          );
        })}
      </div>
    </>
  );
};
export default TopRaffles;
